import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AuthState = {
  isAuthenticated: boolean;
  email: string | null;
  token: string | null;
  jwt: string | null;
  userId: string | null;
  isAdmin: boolean;
  role: 'user' | 'operator' | null;
};

const initialState: AuthState = {
  isAuthenticated: false,
  email: null,
  token: null,
  jwt: null,
  userId: null,
  isAdmin: false,
  role: null,
};

// Try to restore auth from localStorage
const storedAuth = localStorage.getItem('auth');
if (storedAuth) {
  try {
    const parsedAuth = JSON.parse(storedAuth);
    Object.assign(initialState, parsedAuth);
  } catch (e) {
    console.error('Failed to parse stored auth:', e);
  }
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated(
      state,
      action: PayloadAction<{
        email: string;
        token: string;
        jwt: string;
        userId: string;
        isAdmin: boolean;
        role: 'user' | 'operator' | null;
      }>
    ) {
      state.isAuthenticated = true;
      state.email = action.payload.email;
      state.token = action.payload.token;
      state.jwt = action.payload.jwt;
      state.userId = action.payload.userId;
      state.isAdmin = action.payload.isAdmin;
      state.role = action.payload.role;

      // Persist to localStorage
      localStorage.setItem('auth', JSON.stringify(state));
    },
    syncRoleFromUser(state, action: PayloadAction<{ isAdmin: boolean; role: 'user' | 'operator' | null }>) {
      state.isAdmin = action.payload.isAdmin;
      state.role = action.payload.role;
      localStorage.setItem('auth', JSON.stringify(state));
    },
    logout(state) {
      state.isAuthenticated = false;
      state.email = null;
      state.token = null;
      state.jwt = null;
      state.userId = null;
      state.isAdmin = false;
      state.role = null;

      // Clear from localStorage
      localStorage.removeItem('auth');
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
